<template>
  <div>
    <el-dialog
      class="modal"
      title="新增渠道"
      :visible.sync="addModal"
      width="450px"
    >
      <div>
        <el-form
          :inline="true"
          :model="addData"
          class="addForm"
          label-position="top"
        >
          <el-form-item label="名稱">
            <el-input v-model="addData.name" placeholder="名稱"></el-input>
          </el-form-item>
          <el-form-item label="英名稱">
            <el-input
              v-model="addData.eng_name"
              placeholder="英名稱"
            ></el-input>
          </el-form-item>
          <el-form-item label="type">
            <el-input v-model="addData.type" placeholder="type"></el-input>
          </el-form-item>
          <el-form-item label="config_code">
            <el-input
              v-model="addData.config_code"
              placeholder="config_code"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          style="width:100%"
          size="mini"
          block
          @click="addData.channel.push({})"
          >新增</el-button
        >
      </div>
      <div class="channelBox">
        <div
          class="channel"
          v-for="(channel, index) in addData.channel"
          :key="index"
        >
          <span class="close" @click="delChannel(index)"
            ><i class="fas fa-times"></i
          ></span>
          <el-form
            :inline="true"
            :model="addData"
            class="addForm"
            label-position="top"
          >
            <el-form-item label="code">
              <el-input v-model="channel.code" placeholder="code"></el-input>
            </el-form-item>
            <el-form-item label="name">
              <el-input v-model="channel.name" placeholder="name"></el-input>
            </el-form-item>
            <el-form-item label="view">
              <el-input v-model="channel.view" placeholder="view"></el-input>
            </el-form-item>
            <el-form-item label="path">
              <el-input v-model="channel.path" placeholder="path"></el-input>
            </el-form-item>
            <el-form-item label="url">
              <el-input v-model="channel.url" placeholder="url"></el-input>
            </el-form-item>
            <el-form-item label="extra">
              <el-input v-model="channel.extra" placeholder="extra"></el-input>
            </el-form-item>
            <el-form-item label="notify_ip">
              <el-input
                v-model="channel.notify_ip"
                placeholder="notify_ip"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addModal = false" class="btn">關閉</div>
        <div @click="confirmAdd" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="id">
        <el-input v-model="searchData.id" placeholder="id"></el-input>
      </el-form-item>
      <el-form-item label="status">
        <el-select v-model="searchData.status" placeholder="status">
          <el-option label="空" value=""> </el-option>
          <el-option label="未啟用" value="0"> </el-option>
          <el-option label="啟用" value="1"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="type">
        <el-select v-model="searchData.type" placeholder="type">
          <el-option label="空" value=""> </el-option>
          <el-option label="代收" value="0"> </el-option>
          <el-option label="代付" value="1"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <div style="margin-top:18px">
      <el-button type="primary" size="mini" @click="add">新增渠道</el-button>
      <el-table
        stripe
        :data="dataList"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column
          header-align="center"
          align="center"
          label="id"
          width="100px"
        >
          <template slot-scope="scope">
            <div>
              <el-input v-model="scope.row.id"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="name">
          <template slot-scope="scope">
            <div>
              <el-input v-model="scope.row.name"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="eng_name">
          <template slot-scope="scope">
            <div>
              <el-input v-model="scope.row.eng_name"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="type">
          <template slot-scope="scope">
            <div>
              <el-input v-model="scope.row.type"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="config_code"
        >
          <template slot-scope="scope">
            <div>
              <el-input v-model="scope.row.config_code"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="status">
          <template slot-scope="scope">
            <div>
              <el-input v-model="scope.row.status"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="channel"
          width="300"
        >
          <template slot-scope="scope">
            <div>
              <el-input
                type="textarea"
                :rows="5"
                v-model="scope.row.channel"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button @click="editData(scope.row)" size="mini"
                >編輯
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          :current-page.sync="page"
          layout="prev, pager, next"
          :page-count="pagination.total_page"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      inSearch: false,
      saveData: false,
      searchData: {},
      dataList: [],
      pagination: {},
      methodList: [],
      currentDate: [],
      currentData: {},
      addModal: false,
      addData: {
        channel: [{}]
      }
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    delChannel(index) {
      this.addData.channel.splice(index, 1);
    },
    confirmAdd() {
      this.$http.post(`/back/admin/methods`, this.addData).then(res => {
        if (res.data.code == 0) {
          this.addData = {
            channel: [{}]
          };
        }
      });
    },
    add() {
      this.addModal = true;
      this.addData = {
        channel: [{}]
      };
    },
    editData(data) {
      let sendData = JSON.parse(JSON.stringify(data));
      sendData.channel = JSON.parse(sendData.channel);
      this.$alert(`確定編輯${data.name}?`, "編輯", {
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        beforeClose: (method, instance, done) => {
          if (method == "confirm") {
            this.$http
              .put(`/back/admin/methods/${data.id}`, sendData)
              .then(res => {
                if (res.data.code == 0) {
                  this.$message.success("成功");
                  this.getData();
                  done();
                } else {
                  done();
                }
              });
          } else {
            done();
          }
        }
      });
    },
    returnJSON(json) {
      return JSON.stringify(json, undefined, 4);
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
        searchData.lifting_time =
          this.radio == 1 ? "created_at" : "completed_at";
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .get(`/back/admin/methods`, { params: searchData })
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.dataList.forEach(e => {
              e.channel = JSON.stringify(e.channel, undefined, 4);
            });
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.addForm {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .el-form-item {
    width: calc(50% - 10px);
    margin-right: 0 !important;
  }
}
.channelBox {
  // margin-top: 10px;
  .channel {
    position: relative;
    padding: 10px;
    background-color: rgb(235, 229, 229);
    margin-top: 10px;
  }
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
</style>
